<template>
  <el-dialog
    :title="$t('developer.application_setting')"
    :visible.sync="dialogVisible"
    width="800px"
    top="5vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="merchant-app-detail-dialog"
    @close="handleClose"
  >
    <div class="merchant-application-detail">
      <div class="application-detail-switch">
        <div class="grid-content bg-purple-light">
          <el-row class="switch-class">
            <el-col :span="8">
              <div class="grid-content bg-purple-light">
                <p class="setting-title"> {{ $t('developer.shared_application_setting') }}
                  <el-tooltip placement="top">
                    <div slot="content" style="width: 300px">
                      <span>{{ $t('tips.shared_application_setting_tips') }}</span>
                    </div>
                    <svg-icon
                      icon-class="icon-blue-question"
                      class="icon-question-tip"
                    />
                  </el-tooltip>
                </p>
              </div>
            </el-col>
            <el-col :span="16">
              <template>
                <el-switch
                  v-model="form.share_public_key_status"
                  :active-value="1"
                  :inactive-value="2"
                  active-color="#67C23A"
                  inactive-color="#F56C6C"
                  disabled
                />
              </template>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="application-detail-application">
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <p class="setting-title">
                {{ $t('developer.application_information') }}
              </p>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="8">
                  <div class="grid-content bg-purple">
                    <p class="setting-key">AppId:</p>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="grid-content bg-purple">
                    <p class="setting-value">{{ form.app_id }}</p>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple" />
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="application-detail-webhook">
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <p class="setting-title">Webhook</p>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <p class="setting-key">Pay out:</p>
                  </div>
                </el-col>
                <el-col :span="18">
                  <div class="grid-content bg-purple">
                    <el-input v-model="form.notice_webhook" class="search-frame" :placeholder="$t('merchant.notice_webhook')" />
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="application-detail-apiKey">
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <p class="setting-title">API Key</p>
              <div style="width: 80%; margin-top: 20px">
                <p class="setting-title-dec">{{ $t('tips.public_key_introduce') }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="6">
                  <div class="grid-content bg-purple-light">
                    <p class="setting-key"> {{ $t('developer.public_key') }}:</p>
                  </div>
                </el-col>
                <el-col :span="18">
                  <div class="grid-content bg-purple-light">
                    <el-input
                      v-model="form.public_key"
                      type="textarea"
                      :rows="8"
                      clearable
                    />

                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="application-detail-ip">
        <el-row>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <p class="setting-title">{{ $t('developer.ip_white_list') }}
                <el-tooltip placement="top">
                  <div slot="content" style="width: 300px">
                    <span>{{ $t('tips.ip_white_paycools_introduce') }}</span>
                  </div>
                  <svg-icon
                    icon-class="icon-blue-question"
                    class="icon-question-tip"
                  />
                </el-tooltip>
              </p>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="6">
                  <p class="setting-key">{{ $t('developer.ip_address') }}:</p>
                </el-col>
                <el-col :span="16">
                  <div class="grid-content bg-purple-light">
                    <p class="setting-value">{{ form.white_ip }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button>
      <el-button type="primary" :disabled="listLoading" @click="onClickSubmitBtn">
        {{ $t('components.submit') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

import { fetchSubMchAppDetail, updateSubMchApp } from '@/api/agent-merchant/agent-merchant'

export default {
  name: 'Develop_Sub_Manage_App_Detail',
  props: {
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        share_public_key_status: '',
        public_key: ''
      },
      initData: {},
      listLoading: false
    }
  },
  methods: {
    showModal(data) {
      this.$store.dispatch('showMfaDialog', (mfaCode) => {
        this.initData = data
        const params = {
          mfa_code: mfaCode,
          sub_merchant_no: this.initData.merchant_no
        }
        this.getMerchantAppList(params)
      })
    },
    handleClose() {
      this.form = {}
      this.dialogVisible = false
    },
    getMerchantAppList(params) {
      fetchSubMchAppDetail(params).then(res => {
        this.form = res.data || {}
        this.dialogVisible = true
        this.$store.dispatch('hideMfaDialog')
      })
    },
    onClickSubmitBtn() {
      this.listLoading = true
      const { public_key, notice_webhook } = this.form
      const params = {
        public_key,
        notice_webhook,
        sub_merchant_no: this.initData.merchant_no
      }
      this.$store.dispatch('showMfaDialog', (mfaCode) => {
        params.mfa_code = mfaCode
        updateSubMchApp(params).then(res => {
          if (res.code === 10000) {
            this.dialogVisible = false
            this.$store.dispatch('hideMfaDialog')
            this.$message.success('Success')
          }
        }).finally(() => {
          this.listLoading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-question-tip {
  position: relative;
  top: -1px;
  font-size: 12px;
  color: #3855F1;
  height: 20px;
  line-height: 20px;
}
  .el-col{
    min-height:1px;
  }
  .search-frame {
    margin: 5px;
  }
  .submit-btn {
    margin: 5px;
  }
  .merchant-application-detail{
    margin: 0;
    background: #fff;
    border-radius: 4px;
  }
  .application-detail-header {
    width: 100%;
    height: 79px;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-switch {
    width: 100%;
    min-height: 50px;
    padding: 0 0 20px;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-application {
    width: 100%;
    min-height: 50px;
    padding: 24px 0;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-webhook {
    width: 100%;
    min-height: 140px;
    padding: 24px 0;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-apiKey {
    width: 100%;
    min-height: 170px;
    padding: 24px 0;
    border-bottom: 1px solid #D3D7DF;
  }
  .application-detail-ip {
    width: 100%;
    padding: 24px 0;
  }
  p {margin: 0}
  .setting-title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #3855F1;
  }
  .setting-key {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 36px;
    color: #98A1B4;
  }
  .setting-value {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 36px;
    color: #4B5567;
    word-break: break-all;
  }
  .setting-title-dec {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #98A1B4;
  }
  .icon-hover{
   cursor: pointer;
  }
  .icon-hover:hover {
    font-size: 22px;
    color: #3855F1;
  }
  .switch-class{
    display: flex;
    align-items: center;
  }
  .underline {
    display: inline-block;
    width: 100%;
    border-bottom: 1px solid black;
  }
</style>
